import { useCallback, useEffect } from "react";
import { AngularBridge } from "../../other/bridgeSetup/AngularBridge";
import { useTransient, useSingleton } from "../../other/injection";
import { TestBridgeStore } from "./TestBridgeStore";
import { observer } from "mobx-react-lite";
import { AppTimerService } from "../../other/timer/AppTimerService";

interface IProps {
    text: string;
    textChanged: (text: string) => void;
}

export const TestBridge = observer((props: IProps) => {
    const store = useTransient(TestBridgeStore);
    useEffect(() => store.onComponentCreate(), [store]);

    const textUpdate = useCallback(
        (e: React.FormEvent<HTMLInputElement>) => {
            props.textChanged(e.currentTarget.value);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [props.textChanged]
    );

    const err = () => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        const a = {} as any;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        a.error();
    };

    const timer = useSingleton(AppTimerService);
    // eslint-disable-next-line no-console
    console.log("test bridge", timer.timeInMs());

    return (
        <div>
            text in react yo: {props.text}
            <div>
                <input type="text" value={props.text} onChange={textUpdate} />
            </div>
            <AngularBridge name="c-react-test-inner" props={props} />
            <br />
            {store.feedPresets.map(x => (
                <div key={x.Id}>{x.Name}</div>
            ))}
            Test enum value: {store.testEnumValue} <br />
            <button onClick={err}>react error</button>
        </div>
    );
});
